import React, { useState, useEffect } from "react";
import {
  getSingleSignOn,
  resetExceptionError,
  userLogin,
} from "../store/actions/index.js";
import { useSelector, useDispatch } from "react-redux";
import Image from "../assets/images/XL.png";
import MicrosoftLogo from "../assets/images/microsoft.svg";
import { Form, Button } from "react-bootstrap";
import "./Login.css";
import { Link, useNavigate } from "react-router-dom";
import Loader from "./Loader.js";
import Cookies from "js-cookie"; // Import the js-cookie library
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import eye icons
import Logout from "./Logout.js";
// import MaintenancePage from "../../standardpages/MaintenancePage.js";

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider, useMsal } from "@azure/msal-react";

import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import axios from "axios";
import Alert from "./Alert.js";
import { getApiEndpoint } from "../store/apiConfig.js";

export const url = await getApiEndpoint();
function Login() {
  const fetchGetSignleSignOn = useSelector(
    (state) => state.fetchGetSignleSignOn
  );
  // const fetchGetMaintenanceMode = useSelector(
  //   (state) => state.fetchGetMaintenanceMode
  // );
  // const isMaintenanceMode = useSelector((state) => state.isMaintenanceMode);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const isLoggedin = useSelector((state) => state.isLoginFetched);
  const isSubmitted = useSelector((state) => state.submitted);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [showError, setShowError] = useState(false);
  const response = useSelector((state) => JSON.stringify(state.userDetails));
  // const showLoader = useSelector((state) => state.showLoader);

  const [showLoader, setShowLoader] = useState(false);

  const [showGoogleAuthError, setShowGoogleAuthError] = useState(false);
  const [showMicrosoftAuthError, setShowMicrosoftAuthError] = useState(false);
  const [showGoogleSSOButton, setShowGoogleSSOButton] = useState(false);
  const [showMicrosoftSSOButton, setshowMicrosoftSSOButton] = useState(false);
  const [googleSSOClientID, setGoogleSSOClientID] = useState(false);
  const [microsoftSSOClientID, setMicrosoftSSOClientID] = useState(false);

  useEffect(() => {
    const lastLoginUsername = Cookies.get("lastLoginUsername", {
      secure: true,
      sameSite: "None",
    });
    if (lastLoginUsername) {
      setUsername(lastLoginUsername);
    }
  }, []);
  useEffect(() => {
    dispatch(getSingleSignOn());
  }, []);

  useEffect(() => {
    if (fetchGetSignleSignOn && fetchGetSignleSignOn?.status === 200) {
      if (fetchGetSignleSignOn?.message) {
        setShowGoogleSSOButton(
          fetchGetSignleSignOn?.message?.enable_google_sso !== 0
        );
        setshowMicrosoftSSOButton(
          fetchGetSignleSignOn?.message?.enable_microsoft_sso !== 0
        );
        setGoogleSSOClientID(
          fetchGetSignleSignOn?.message?.google_sso_client_id
        );
        setMicrosoftSSOClientID(
          fetchGetSignleSignOn?.message?.microsoft_sso_client_id
        );
      }
    }
  }, [fetchGetSignleSignOn]);

  useEffect(() => {
    if (isLoggedin) {
      var response = JSON.parse(localStorage.getItem("userDetails"));
      if (response?.ok) {
        if (response) {
          if (response.data["message"] === "No App" || response.data["message"] === "Logged In") {
            localStorage.setItem(
              "token",
              response.data["api_key"] + ":" + response.data["api_secret"]
            );
            localStorage.setItem("authenticated", true);
            localStorage.setItem("full_name", response.data["full_name"]);
            // Cookies.set("sid", response.data["sid"]);
            navigate("/dashboard");
            setShowLoader(false);
          } else {
            setShowLoader(false);
            setShowError(true);
          }
        }
      } else if (response?.status == 403) {
        setShowLoader(false);
        setShowError(true);
      } else {
        setShowLoader(false);
        setShowError(true);
      }
    }
  }, [isLoggedin, isSubmitted]);

  const handleSubmit = (event) => {
    event.preventDefault();
    setShowLoader(true);
    setShowError(false);
    setSubmitted(!submitted);
    dispatch(userLogin(username, password, submitted));
    Cookies.set("lastLoginUsername", username);
  };
  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  // useEffect(() => {
  //   dispatch(getIsMaintenanceMode());
  // }, [dispatch]);
  // const [showurls, setshowurls] = useState(false);

  // useEffect(() => {
  // if (fetchGetMaintenanceMode && fetchGetMaintenanceMode.status === 200) {
  //   dispatch({
  //     type: "IS_MAINTENANCE_MODE",
  //     value: fetchGetMaintenanceMode.is_maintenance === 1,
  //   });
  // setshowurls(true);
  // }
  // }, [dispatch]);

  // if (isMaintenanceMode) {
  //   return (
  //     <>
  //       <Logout />
  //       <MaintenancePage />
  //     </>
  //   );
  // }

  const handleLoginSuccess = async (credentialResponse) => {
    try {
      // credentialResponse contains the ID token

      const token = credentialResponse.credential;
      // Send token to Frappe backend
      const res = await axios.post(
        url + "/api/method/excelrate.api.sso_login.custom_login_with_google",
        { token },
        { withCredentials: true } // Important: send cookies
      );

      localStorage.setItem(
        "token",
        res.data["api_key"] + ":" + res.data["api_secret"]
      );
      localStorage.setItem("authenticated", true);
      localStorage.setItem("full_name", res.data["full_name"]);
      navigate("/dashboard");
      setShowLoader(false);
      // Now user session is created, you can redirect
    } catch (error) {
      console.error("Login failed:", error.response?.data || error.message);
      setShowGoogleAuthError(true);
    }
  };

  const msalConfig = {
    auth: {
      clientId: microsoftSSOClientID,
    },
  };

  const pca = new PublicClientApplication(msalConfig);

  function MicrosoftLoginButtonCustom() {
    const navigate = useNavigate();
    const { instance } = useMsal();

    const handleMicrosoftLogin = async () => {
      try {
        const loginResponse = await instance.loginPopup({
          scopes: ["openid", "profile", "email"],
        });

        const id_token = loginResponse.idToken;

        // Send token to frappe backend
        const res = await axios.post(
          url +
            "/api/method/excelrate.api.sso_login.custom_login_with_microsoft",
          { id_token },
          { withCredentials: true }
        );

        // Save login state
        localStorage.setItem(
          "token",
          res.data["api_key"] + ":" + res.data["api_secret"]
        );
        localStorage.setItem("authenticated", true);
        localStorage.setItem("full_name", res.data["full_name"]);
        navigate("/dashboard");
        setShowLoader(false);
      } catch (err) {
        console.error("Login failed:", err.response?.data || err.message);
        setShowMicrosoftAuthError(true);
      }
    };

    return (
      <button className="microsoft-login-custom" onClick={handleMicrosoftLogin}>
        <img
          src={MicrosoftLogo}
          alt="Microsoft"
          style={{ width: "20px", position: "relative", left: -85 }}
        />
        Sign in with Microsoft
      </button>
    );
  }

  return (
    <>
      {showLoader && <Loader />}
      <div
        className="pagecenter loginForm"
        style={{ padding: "10%", width: "100%" }}
      >
        <Form
          className="modal-content animate"
          onSubmit={handleSubmit}
          style={{ width: "500px", maxWidth: "500px" }}
        >
          <div
            className="container1"
            style={{ width: "90%", paddingBottom: "5%", paddingLeft: "10%" }}
          >
            <h3 style={{ textAlignVertical: "center", textAlign: "center" }}>
              <img style={{ width: "7%" }} src={Image} />
              Excelrate GEMS
            </h3>
            <Form.Group size="lg" controlId="text">
              <Form.Control
                autoFocus
                name="username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                placeholder="Enter Username"
                autoComplete="off"
              />
            </Form.Group>

            <Form.Group size="lg" controlId="password">
              <Form.Control
                name="password"
                style={{ position: "relative" }}
                type={passwordVisible ? "text" : "password"}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Enter Password"
              />
              <span
                className="password-toggle-login"
                onClick={togglePasswordVisibility}
              >
                {passwordVisible ? <FaEyeSlash /> : <FaEye />}
              </span>
            </Form.Group>
            {showError && (
              <span style={{ color: "red" }}>Invalid Username/Password</span>
            )}
            {(showGoogleAuthError || showMicrosoftAuthError) &&
              Alert.error({
                title: "Invalid User",
                text: "You don't have permissions to login. Please contact your Administrator.",
                icon: "warning",
                preConfirm: (isConfirm) => {
                  if (isConfirm) {
                    navigate("/logout");
                    dispatch(resetExceptionError());
                    window.location.reload();
                  } else {
                  }
                },
              })}
            <Button size="lg" type="submit" style={{ height: "50px" }}>
              Login
            </Button>
            <div className="forgot-password-login">
              <Link to="/forgot-password">Forgot Password?</Link>
            </div>
            {showGoogleSSOButton && (
              <GoogleOAuthProvider clientId={googleSSOClientID}>
                <div className="google-login">
                  <GoogleLogin
                    onSuccess={handleLoginSuccess}
                    onError={() => setShowGoogleAuthError(true)}
                  />
                </div>
              </GoogleOAuthProvider>
            )}
            {showMicrosoftSSOButton && (
              <MsalProvider instance={pca}>
                <MicrosoftLoginButtonCustom />
              </MsalProvider>
            )}
          </div>
        </Form>
      </div>
    </>
  );
}

export default Login;
